import { redirect } from "react-router-dom";

import { IS_IN_IFRAME } from "@src/env";
import { navigationV2 } from "@src/shared/navigation/v2";

export function clientLoader() {
  return redirect(IS_IN_IFRAME ? navigationV2.login() : navigationV2.visits());
}

export function HomeV2Route() {
  return null;
}
